ticket.ticketWinCurrencyModule = {
    // Funkcia sluzi na aktivaciu/deaktivaciu winow v kalkulacke rozpracovaneho tiketu
    activationTrigger: function() {
        try {
            if (stored.PlayerID && stored.PlayerID === profile.ManualVerifiedPlayerID) {
                // Manualne overeny hrac nema pristup k win currency
                modal.openVLCModal("NO_PLAYER_TEASER");
            } else if (stored.PlayerID) {
                // Aktivaciu dovoli len prihlasenemu hracovi
                if (ticket.state.getState().isWinCurrencyTicket) {
                    ticket.ticketWinCurrencyModule.deactivate();
                } else {
                    ticket.ticketWinCurrencyModule.activate();
                }
            } else {
                // Vyzva na prihlasenie v pripade, ze hrac nie je prihlaseny, winy su dostupne len pre prihlasenych hracov
                modal.openVLCModal("NO_PLAYER_WINCURRENCY");
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    deactivate: function() {
        // Vypnutie zadavania vkladu za winy
        ticket.state.setState({ isWinCurrencyTicket: false });
        document.getElementById("bonificationAvailable")?.classList.remove("ui-disabled");
        document.getElementById("freebetAvailable")?.classList.remove("ui-disabled");
        document.querySelector(".deposit-dial__button--currency").classList.remove("deposit-dial__button--active");
        document.querySelector("#displayDial").classList.remove("deposit-dial__display--win-currency-active");
        // Popocita celkovu stávku v prípade, aby sa zabezpečilo správne manipulacneho poplatku, vyhry
        ticket.checkSum();
    },

    activate: function() {
        // Zapnutie zadavania vkladu za winy - deaktivuje moznost pouzitia freebetov a bonifikacii, kedze tie sa pocitaju v klasickej mene
        ticket.state.setState({ isWinCurrencyTicket: true });
        ticket.ticketPromoModule.clearFreebetBonification(true, false, "freebet");
        ticket.ticketPromoModule.clearFreebetBonification(true, false, "bonification");
        document.getElementById("bonificationAvailable")?.classList.add("ui-disabled");
        document.getElementById("freebetAvailable")?.classList.add("ui-disabled");
        document.querySelector(".deposit-dial__button--currency").classList.add("deposit-dial__button--active");
        document.querySelector("#displayDial").classList.add("deposit-dial__display--win-currency-active");
        // Popocita celkovu stávku v prípade, ze je win currency aktivny, aby sa zabezpečilo správne manipulacneho poplatku, vyhry
        ticket.checkSum();
    },

    // Funkcia sluzi na zobrazenie informacneho modalu k winom
    winCurrencyInfo: function() {
        try {
            modal.showInfoModal("WinCurrencyInfoModal", sets.watcherTime, false, texts.TicketWinCurrencyInfoModalHeader, texts.TicketWinCurrencyInfoModalInfo, false, false,
                {
                    buttonCloseText: texts.TicketWinCurrencyInfoModalClose,
                    buttonCloseAction: "modal.hideInfoModal();",
                    button2Text: texts.TicketWinCurrencyInfoModalMoreInfo,
                    button2Action: "ticket.ticketWinCurrencyModule.showWinCurrencyBonusInfoPage();"
                });
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na zobrazenie bonusovej page k winom
    showWinCurrencyBonusInfoPage: function() {
        try {
            modal.hideInfoModal();
            main.openPage("club", false, function() {
                more.menu.clubPage(11);
            });
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na zobrazenie moznosti prihlasenia
    noPlayerWinCurrencyLoginOptions: function() {
        try {
            if (profile.BiometryLogin) {
                // Prejde na prihlasenie pomocou biometrie
                player.biometryLogin();
            } else {
                // Ak nieje moznost prihlasnia biometriou tak ponukne len moznost 
                openVLCModal("NO_PLAYER", false, true);
            }
        }
        catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia sluzi na aktualizaciu stavu win currency pre hraca
    updateWinCurrencyClientBalance: function() {
        try {
            if (stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID) {
                if (typeof WebAppUserActivity === "function") {
                    // Zavolanim GetWinCurrencyClientBalance nativeApp odpovie setWinCurrencyClientBalance(winCurrencyBalance)
                    GetWinCurrencyClientBalance();
                }
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }
};
